import { addToListModalStyles } from "@insite/content-library/Components/AddToListModal";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

// AddtoListModal

addToListModalStyles.listsSelect = {
    cssOverrides: {
        formField: css`
            margin-top: 15px;
            > div[class^="FormInputWrapper"] {
                > div[class^="OverflowWrapper"] {
                    > ul[data-test-selector="productAddToListModal_listSelect-listbox"] {
                        max-height: 120px;
                    }
                }
            }
        `,
    },
};
addToListModalStyles.buttonsWrapper = {
    css: css`
        margin-top: 60px;
        text-align: right;
    `,
};

addToListModalStyles.modal = {
    size: 350,
    cssOverrides: {
        modalTitle: css`
            padding: 10px 20px;
        `,
        modalContent: css`
            padding: 20px;
            height: 250px;
        `,
    },
};
